module.exports = __webpack_public_path__ + "img/restaurant-banner3.b8c60f54.jpeg";